<template>
  <section class="content">
    <div class="box box-info">
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="p-toolbar p-component mb-4">
        <Button class="p-button p-component p-button-success" 
                icon="pi pi-plus" 
                label="NEW"
                @click.prevent="openAddDialog" />
      </div>
      <DataTable :value="organizationLists"
                 :paginator="true"
                 :rows="8"
                 :filters="filters"
                 class="p-datatable-responsive p-datatable-customers">
        <Column header="S.n">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column header="Name" field="name" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['name']" />
          </template>
        </Column>
        <Column header="Short Name" field="shortName" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['shortName']" />
          </template>
        </Column>
        <Column header="Contact Person" field="contactPerson" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['contactPerson']" />
          </template>
        </Column>
        <Column header="Address" field="address" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['address']" />
          </template>
        </Column>
         <Column header="Type" field="taxType" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['taxType']" />
          </template>
        </Column>
        <Column header="Merge">
          <template #body="slotProps">
            <Checkbox :binary="true" 
                      v-model="slotProps.data.mergeOrg" 
                      @change="updateMergeStatus(slotProps.data)" />
          </template>
        </Column>
        <Column header="Action">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" 
                    class="p-button-raised p-button-success" 
                    @click="editOrganization(slotProps.data)" />
            <Button icon="pi pi-trash" 
                    class="p-button-raised p-button-danger" 
                    @click="openDeleteDialog(slotProps.data.id)" />
          </template>
        </Column>
      </DataTable>
      <Dialog :visible.sync="addDisplayBasic" 
              header="Organization Details"
              :style="{width: '50vw'}"
              :modal="true"
              :closable="false">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12">
            <h4 style="color:#3c8dbc; margin-bottom:20px">Organization Info</h4>
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name <span style="color:red">*</span></label>
            <InputText id="name" v-model.trim="name" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="shortName">Short Name</label>
            <InputText id="shortName" v-model.trim="shortName" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="contactPerson">Contact Person</label>
            <InputText id="contactPerson" v-model.trim="contactPerson" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="contactNumber">Contact Number</label>
            <InputText id="contactNumber" 
                       v-model.trim="contactNumber"
                       @keypress="isNumber($event)" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="email">Email</label>
            <InputText id="email" v-model.trim="email" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="address">Address</label>
            <InputText id="address" v-model.trim="address" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="organizationType">Organization Type</label>
            <Dropdown v-model="taxType" 
                      :options="organizationTypes"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Type" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="panNo">Pan/Vat No</label>
            <InputText id="panNo" 
                       v-model.trim="panNo"
                       @keypress="isNumber($event)" />
          </div>
          <div class="p-field p-col-12">
            <label>Image</label>
            <div class="flex gap-2 mt-2">
              <Button label="Upload Image" 
                      icon="pi pi-upload"
                      class="p-button-raised"
                      @click.prevent="showItemUpload" />
              <Button v-if="imageList.length > 0" 
                      label="View Images" 
                      icon="pi pi-images"
                      class="p-button-raised p-button-success"
                      @click.prevent="viewImage" />
            </div>
          </div>
          <template v-if="!editing">
            <div class="p-field p-col-12">
              <h4 style="color:#3c8dbc; margin:20px 0">User Info</h4>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <label for="userName">Full Name <span style="color:red">*</span></label>
              <InputText id="userName" v-model.trim="nameOfuser" />
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <label for="username">Username <span style="color:red">*</span></label>
              <InputText id="username" v-model.trim="username" />
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <label for="password">Password</label>
              <InputText id="password" 
                         v-model.trim="password" 
                         disabled />
            </div>
          </template>
        </div>
        
        <template #footer>
          <Button :label="editing ? 'Update' : 'Add'" 
                  class="p-button-raised p-button-primary"
                  @click.prevent="addOrganisation" />
          <Button label="Cancel" 
                  class="p-button-raised p-button-secondary"
                  @click.prevent="addCancel" />
        </template>
      </Dialog>
      <Dialog header="Upload Images" 
              :visible.sync="showItemUploadDialog" 
              :style="{width: '50vw'}"
              :modal="true">
        <div class="p-fluid">
          <input type="file" id="fileInput" class="hidden" multiple @change="onFileSelect" />
          <label for="fileInput" class="p-button p-component p-button-outlined mb-4">
            <i class="pi pi-upload mr-2"></i>Select Images (max 1MB)
          </label>
          
          <Carousel :value="previewImages" :numVisible="3" :numScroll="1" circular>
            <template #item="slotProps">
              <div class="border-1 surface-border border-round m-2 text-center py-5 px-3">
                <div class="mb-3">
                  <img :src="slotProps.data.url" class="w-6 shadow-2" style="max-height: 200px;" />
                  <div class="file-size">{{ formatFileSize(slotProps.data.size) }}</div>
                </div>
                <div>
                  <Button icon="pi pi-trash" 
                          class="p-button-danger"
                          @click="removeNewImage(slotProps.index)" />
                </div>
              </div>
            </template>
          </Carousel>
        </div>
        <template #footer>
          <Button label="Back" 
                  class="p-button-outlined"
                  @click.prevent="closeImageUpload" />
          <Button label="Cancel" 
                  class="p-button-danger"
                  @click.prevent="cancelImageUpload" />
        </template>
      </Dialog>
<Dialog
 :visible.sync="deleteDialogVisible"
  header="Are you sure you want to delete?"
  :style="{width: '40vw'}"
  :modal="true"
  :closable="false"
>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label for="deleteReason" style="font-size:12px">Delete Reason:</label>
      <div class="p-col-12 p-md-10">
        <Textarea id="deleteReason" rows="5" v-model="deleteReason"/>
      </div>
    </div>
  </div>
  <template #footer>
    <Button class="p-button-raised p-button-danger" @click.prevent="deleteOrganization" label="Cancel"/>
    <Button class="p-button-raised p-button-success" @click="deleteDialogVisible = false" label="Back"/>
  </template>
  </Dialog>
      <!-- Delete Confirmation Dialog -->
      <!-- <Dialog :visible.sync="deleteDialogVisible"
              header="Confirm Deletion"
              :style="{width: '40vw'}"
              :closable="false"
              :modal="true">
        <p>Are you sure you want to delete this organization?</p>
        <Textarea v-model="deleteReason" placeholder="Enter deletion reason" rows="5" class="w-full mt-3" />
        
        <template #footer>
          <Button label="Yes" 
                  class="p-button-danger"
                  @click="deleteOrganization" />
          <Button label="No"
                  class="p-button-secondary"
                  @click="deleteDialogVisible = false" />
        </template>
      </Dialog> -->
    </div>
  </section>
</template>

<script>
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Carousel from 'primevue/carousel'
import Textarea from 'primevue/textarea/Textarea'
import Checkbox from 'primevue/checkbox'
export default {
  components: {
    Button,
    Checkbox,
    DataTable,
    Column,
    Dialog,
    InputText,
    Textarea,
    Dropdown,
    Carousel
  },
  data() {
    return {
      name: '',
      shortName: '',
      contactPerson: '',
      contactNumber: '',
      previewImages: [],
      email: '',
      address: '',
      taxType: '',
      panNo: '',
      nameOfuser: '',
      username: '',
      password: '123456',
      website: '',
      isEnglishDate: '',
      images: [],
      url: [],
      deletedImage: [],
      imageList: [],
      showItemUploadDialog: false,
      openImageViewer: false,
      editing: false,
      loading: false,
      addDisplayBasic: false,
      deleteDialogVisible: false,
      organizationIdToDelete: null,
      deleteReason: '',
      filters: {},
      organizationTypes: [
        { name: 'Vat', value: 'vat' },
        { name: 'Pan', value: 'pan' }
      ],
      dateTypes: [
        { name: 'English', value: true },
        { name: 'Nepali', value: false }
      ]
    }
  },
  computed: {
    organisationId() {
      return this.$store.getters.organisationId
    },
    organizationLists() {
      return this.$store.state.admin.organizationLists
    }
  },
  mounted() {
    this.loadOrganizations()
  },
  methods: {
    async loadOrganizations() {
      await this.$store.dispatch('loadOrganizationByParent')
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    editOrganization(org) {
      this.editing = true
      this.name = org.name
      this.shortName = org.shortName
      this.contactPerson = org.contactPerson
      this.contactNumber = org.contactNumber
      this.email = org.email
      this.address = org.address
      this.taxType = org.taxType
      this.panNo = org.panNumber
      this.id = org.id
      this.website = org.website || ''
      this.isEnglishDate = org.englishDateTransaction
        ? { name: 'English', value: true }
        : { name: 'Nepali', value: false }
      if (org.imageList) {
        this.imageList = org.imageList
      }
      this.openAddDialog()
    },
    async updateMergeStatus(org) {
      try {
        let res = await this.$store.dispatch('updateMergeFlag', {
          orgId: org.id,
          mergeOrg: org.mergeOrg
        })
        if (res.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Merge status updated',
            life: 3000
          })
        }
      } catch (error) {
        org.mergeOrg = !org.mergeOrg
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update merge status',
          life: 3000
        })
      }
    },
    openDeleteDialog(orgId) {
      this.organizationIdToDelete = orgId
      this.deleteDialogVisible = true
    },
    async addOrganisation() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter name!', life: 10000})
        return
      }
      let user = {
        username: this.username,
        name: this.nameOfuser,
        password: this.password
      }
      if (this.isEnglishDate === 'English') {
        this.isEnglishDate = true
      } else {
        this.isEnglishDate = false
      }
      let organisation = {
        name: this.name,
        shortName: this.shortName,
        contactNumber: this.contactNumber,
        telPhone: this.telcontact,
        address: this.address,
        email: this.email,
        contactPerson: this.contactPerson,
        taxType: this.taxType,
        id: this.id,
        panNumber: this.panNo,
        englishDateTransaction: this.isEnglishDate,
        userDTO: user,
        webSite: this.website,
        deletedImage: this.deletedImage,
        parentId: this.organisationId
      }
      const formData = new FormData()
      formData.append('organisation', JSON.stringify(organisation))
      this.previewImages.forEach(item => {
        formData.append('files', item.file)
      })
      let resp = ''
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createOrganization', formData)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateOrganization', formData)
        this.loading = false
      }
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    onFileSelect(event) {
      const maxSize = 1048576
      const files = event.target.files
      if (!files || files.length === 0) return
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (file.size > maxSize) {
          this.$toast.add({
            severity: 'error',
            summary: 'File too large',
            detail: `"${file.name}" exceeds 1MB limit`,
            life: 5000
          })
          continue
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.previewImages.push({
            url: e.target.result,
            size: file.size,
            file: file
          })
        }
        reader.readAsDataURL(file)
      }
      event.target.value = null
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' bytes'
      else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / 1048576).toFixed(1) + ' MB'
    },
    removeNewImage(index) {
      if (index >= 0 && index < this.previewImages.length) {
        this.previewImages.splice(index, 1)
      }
    },
    viewImage() {
      this.openImageViewer = true
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    closeImageUpload() {
      this.showItemUploadDialog = false
    },
    cancelImageUpload() {
      this.showItemUploadDialog = false
      this.url = []
      this.images = []
    },
    async deleteOrganization() {
      if (!this.deleteReason) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Deletion reason required', life: 3000})
        return
      }
      this.loading = true
      try {
        await this.$store.dispatch('deleteOrganization', {
          id: this.organizationIdToDelete,
          deleteReason: this.deleteReason
        })
        this.$toast.add({severity: 'success', summary: 'Deleted', detail: 'Organization deleted', life: 3000})
        this.loadOrganizations()
      } catch (error) {
        console.error('Deletion failed:', error)
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Deletion failed', life: 3000})
      } finally {
        this.deleteDialogVisible = false
        this.loading = false
      }
    },
    reset() {
      this.editing = false
      this.name = ''
      this.email = ''
      this.address = ''
      this.contactNumber = ''
      this.contactPerson = ''
      this.shortName = ''
      this.telcontact = ''
     // this.closeAddDialog()
      this.secondaryContact = ''
      this.contactPerson = ''
      this.panNo = ''
      this.taxType = ''
      this.username = ''
      this.nameOfuser = ''
      this.website = ''
      this.isEnglishDate = ''
      this.images = []
      this.url = []
      this.imageList = []
      this.deletedImage = []
    },
    addCancel() {
      this.reset()
      this.addDisplayBasic = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped src="@../../../static/css/dialogEntry.css">
.file-size {
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// branchCompany.vue?3ea3ed28